if (document.querySelector(".user--loggedin")) {
  const userProfileButton = document.querySelector(".user--nav-item");
  const userProfile = document.querySelector(".user--profile");
  const closeButton = userProfile.querySelector(".user--profile-close");
  const userLoggedIn = document.querySelector(".user--loggedin");

  userProfileButton.addEventListener("click", e => {
    userProfile.classList.toggle("active");
    userLoggedIn.classList.toggle("active");
    //   if (userProfile.classList.contains("active")) {
    //     document.body.addEventListener("click", e => {
    //       if (
    //         !e.target.classList.contains("user--profile") ||
    //         !e.target.parentElement.classList.contains("user--profile")
    //       ) {
    //         userProfile.classList.remove("active");
    //       }
    //     });
    //   }
  });
  closeButton.addEventListener("click", e => {
    userProfile.classList.remove("active");
    userLoggedIn.classList.remove("active");
  });
}
